export default "__VITE_ASSET__peU6um9a__"